import { render, staticRenderFns } from "./EntityNameForms.vue?vue&type=template&id=24a40698&"
import script from "./EntityNameForms.vue?vue&type=script&lang=js&"
export * from "./EntityNameForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports